import React from 'react';
import { fRef } from '../../utils/React.js';
import { MenulikeItemPresentation } from '../MenulikeItem/MenulikeItemPresentation.js';

var SelectOptionPresentation = fRef(function (_ref) {
  var highlight = _ref.highlight,
    selected = _ref.selected,
    disabled = _ref.disabled,
    label = _ref.label,
    id = _ref.id,
    onClick = _ref.onClick,
    onMouseOver = _ref.onMouseOver,
    ref = _ref.ref,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(MenulikeItemPresentation, {
    id: id,
    onClick: onClick,
    disabled: disabled,
    onMouseOver: onMouseOver,
    ref: ref,
    hasTabIndex: true,
    role: "option",
    "aria-selected": selected,
    "aria-disabled": disabled,
    highlight: highlight
  }, label || children);
});
SelectOptionPresentation.displayName = "SelectOptionPresentation";

export { SelectOptionPresentation };
